<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'系统配置'},{name:'banner列表',goback:true},{name:'发布banner'}]" :title="'发布banner'"/> -->
            <!-- 表单 -->
            <div class="box">
               <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>机构名称：</div>
                        <el-input v-model="sendInfo.mechanism"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfo.mechanism']">错误提示：{{errors['sendInfo.mechanism']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>LOGO：</div>
                        <div class="content">
                          <upLoad :action="'backstage/annex/file'"  
                          @input="inputValue" :accept="'image/png,image/jpg,image/jpeg'"
                          :size="20" :value="sendInfo.logo" is-need-limit
            :sizeList="[1 / 1]"
            :fixedNumber='[1,1]'
            :autoCropWidth="200"
            :autoCropHeight='200'/></div>
                         </div>
                    <div class="hint">图片仅支持png、jpg，建议高宽比为1:1，尺寸建议200*200px，大小不超过20M</div>
                    <div class="error" v-if="errors['sendInfo.logo']">错误提示：{{errors['sendInfo.logo']}}</div>

                    <div class="child childTextarea">
						<div class="name"><span>*</span>介绍：</div>
                        <div class="content"><el-input type="textarea"  v-model="sendInfo.remarks" show-word-limit maxlength="500"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.remarks']">错误提示：{{errors['sendInfo.remarks']}}</div>

                    <div class="child">
                      <div class="name"></div>
                      <div class="content">
                          <div class="doubleBtn">
                            <el-button size="small" type="primary" @click="submit">确认</el-button>
                            <el-button size="small" @click="$router.back(-1)">取消</el-button>
                            <!-- <el-button size="small" @click="$router.back(-1)">返回</el-button> -->
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../../components/upLoads';
export default {
    components:{
        // breadcrumb,
        upLoad
    },
    data(){
        return{
            sendInfo:{
                id:'',
                mechanism:'',//机构名称
                logo:'',//logo
                remarks:'',//介绍
            },
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.mechanism':{
            test:function(){
                if(this.sendInfo.mechanism){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写介绍'
        },
        'sendInfo.logo':{
            test:function(){
                if(this.sendInfo.logo.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'上传LOGO图片'
        },
        'sendInfo.remarks':{
            test:function(){
                if(this.sendInfo.remarks){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写介绍'
        }
    },
    mounted(){
      const {id} = this.$route.params
      const row = window.localStorage.getItem('hzjg')? JSON.parse(window.localStorage.getItem('hzjg')): void 0
      if(row){//编辑
                this.sendInfo.id = row.id
                this.sendInfo.mechanism = row.mechanism
                this.sendInfo.logo = row.logo
                this.sendInfo.remarks = row.remarks
                this.dialogEdit=true;
                this.dialogEditTitle='编辑合作机构';
            }else{ //发布
                this.sendInfo.id = ''
				this.sendInfo.mechanism = ''
				this.sendInfo.logo = ''
				this.sendInfo.remarks = ''
                this.dialogEdit=true;
                this.dialogEditTitle='添加合作机构';
				this.$vuerify.clear();
            }
    },
    methods:{
      inputValue(val){
            this.sendInfo.logo = val
        },
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axioscBody.post('backstage/fund/saveFundMechanism',this.sendInfo).then(res=>{
                    if(res.code == 200){
                        this.$message({
                            type: 'success',
                            message: this.sendInfo.id?'编辑成功!':'添加成功'
                        });
                        this.$router.back(-1)
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        //取消
        cancel:function(){
            this.sendInfo.name1='';
            this.sendInfo.name2=[];
            this.sendInfo.name3='';
            this.$vuerify.clear();
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding:100px 0;
    .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
    .childList{
        max-width: 700px;
        /deep/ .el-radio{
            margin-top: 10px;
            width: 100px;
        }
    }
}
.error{
  text-indent: 95px !important;
}
.forms{
  .name{
    span{
      color:red;
    }
  }
}
</style>